var Headers = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('auth_token') 
}

export default Headers